import { render, staticRenderFns } from "./icon-with-background.vue?vue&type=template&id=71568508&"
import script from "./icon-with-background.vue?vue&type=script&lang=js&"
export * from "./icon-with-background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71568508')) {
      api.createRecord('71568508', component.options)
    } else {
      api.reload('71568508', component.options)
    }
    module.hot.accept("./icon-with-background.vue?vue&type=template&id=71568508&", function () {
      api.rerender('71568508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/icon-with-background/icon-with-background.vue"
export default component.exports